export default function updateStyling(targetWindow, invocableKey, args) {
        if (!invocableKey) {
            return null;
        }

        if (!args) {
            return null;
        }
        
        targetWindow.postMessage({"messageType":"updateStyling","messageData":{"invocableType": invocableKey,"arguments": args }}, "*")
    }